import type { ElementType, ReactNode } from 'react';

export function SettingsSection({ title, description, icon: Icon, headerAside, children }: {
  title: string; description?: string; icon: ElementType; headerAside?: ReactNode; children: ReactNode;
}) {
  return <section className="rounded-xl border border-gray-200 bg-white p-5">
    <header className="flex items-start gap-3 border-b border-gray-100 pb-5">
      <span aria-hidden className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary"><Icon size={20} /></span>
      <div className="min-w-0 flex-1"><h3 className="text-base font-semibold text-gray-900">{title}</h3>
        {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}</div>
      {headerAside && <div className="shrink-0">{headerAside}</div>}
    </header>
    {children}
  </section>;
}
